import React, { useState } from "react";
import Toast from "react-bootstrap/Toast";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Intrest.css";

// Icons (replace with your actual image imports)
import icon1 from "../../assets/icons/react.png";
import icon2 from "../../assets/icons/html.jpeg";
import icon3 from "../../assets/icons/js.jpeg";
import icon4 from "../../assets/icons/python.png";
import icon5 from "../../assets/icons/css.webp";

function Interests() {
  const [activeToast, setActiveToast] = useState(null); // Tracks which toast is active

  // Toast Data
  const toasts = [
    {
      id: 1,
      title: "React",
      desc: "React is a JavaScript library for building UI.",
      langurl: "https://react.dev/",
      icon: icon1,
    },
    {
      id: 2,
      title: "HTML",
      desc: "HTML structures the content of web pages.",
      langurl: "https://developer.mozilla.org/en-US/docs/Web/HTML",
      icon: icon2,
    },
    {
      id: 3,
      title: "JavaScript",
      desc: "JavaScript adds interactivity to web pages.",
      langurl: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
      icon: icon3,
    },
    {
      id: 4,
      title: "Python",
      desc: "Python is great for AI and data science.",
      langurl: "https://www.python.org/",
      icon: icon4,
    },
    {
      id: 5,
      title: "CSS",
      desc: "CSS styles and beautifies web pages.",
      langurl: "https://developer.mozilla.org/en-US/docs/Web/CSS",
      icon: icon5,
    },
  ];

  // Handle click on icon
  const handleClick = (id) => {
    setActiveToast(activeToast === id ? null : id); // Correctly toggles state
  };

  return (
    <div className="interests-container">
      <h1 className="section-title" data-aos="fade-up">
         Languages I'm Interested In
      </h1>
      <div className="interests-grid">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className="icon-wrapper"
            data-aos="fade-up"
            onClick={() => handleClick(toast.id)}
          >
            <img src={toast.icon} alt={toast.title} className="circular-icon" />
            <div
              className={`custom-toast ${
                activeToast === toast.id ? "show" : ""
              }`}
            >
              <Toast onClose={() => setActiveToast(null)}>
                <Toast.Header>
                  <img
                    src={toast.icon}
                    alt=""
                    className="rounded me-2"
                    style={{ width: 20, height: 20 }}
                  />
                  <strong className="me-auto">{toast.title}</strong>
                </Toast.Header>
                <Toast.Body>
                  {toast.desc}
                  <br />
                  {/* Read More Link */}
                  <a
                    href={toast.langurl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#007bff", textDecoration: "underline" }}
                  >
                    Read More
                  </a>
                </Toast.Body>
              </Toast>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Interests;
